<template>

    <div v-if="editor" class="container float-left mb-2">
      <div class="control-group">
        <div class="button-group editor flex gap-3 mb-3 mt-4 bg-white p-3 rounded-lg pl-4 pr-4 justify-between">

          <button @click="editor.chain().focus().addColumnBefore().run()" :disabled="!editor.can().addColumnBefore()">
            Add column before
          </button>

          <button @click="editor.chain().focus().addColumnAfter().run()" :disabled="!editor.can().addColumnAfter()">
            Add column after
          </button>

          <button @click="editor.chain().focus().deleteColumn().run()" :disabled="!editor.can().deleteColumn()">
            Delete column
          </button>

          <button @click="editor.chain().focus().addRowBefore().run()" :disabled="!editor.can().addRowBefore()">
            Add row before
          </button>

          <button @click="editor.chain().focus().addRowAfter().run()" :disabled="!editor.can().addRowAfter()">
            Add row after
          </button>
          <button @click="editor.chain().focus().deleteRow().run()" :disabled="!editor.can().deleteRow()">
            Delete row
          </button>

          <button @click="editor.chain().focus().deleteTable().run()" :disabled="!editor.can().deleteTable()">
            Delete table
          </button>

          <button @click="setLink">
            Add Link
          </button>

          <button>
            <i class="fa-solid fa-chevron-down" @click="toggleSecondRow" v-if="this.secondRow === false"></i>
            <i class="fa-solid fa-chevron-up" @click="toggleSecondRow" v-else></i>
          </button>

        </div>
        <div class="button-group editor flex gap-3 mb-3 mt-4 bg-white p-3 rounded-lg pl-4 pr-4 justify-between" v-if="secondRow" style="margin-top: -1rem; border-radius: 0px 0px 10px 10px; padding-bottom: 1rem;">



          <button @click="editor.chain().focus().mergeCells().run()" :disabled="!editor.can().mergeCells()">
            Merge cells
          </button>
          <button @click="editor.chain().focus().splitCell().run()" :disabled="!editor.can().splitCell()">
            Split cell
          </button>

          <button @click="editor.chain().focus().toggleHeaderColumn().run()" :disabled="!editor.can().toggleHeaderColumn()">
            Toggle header column
          </button>
          <button @click="editor.chain().focus().toggleHeaderRow().run()" :disabled="!editor.can().toggleHeaderRow()">
            Toggle header row
          </button>
          <button @click="editor.chain().focus().toggleHeaderCell().run()" :disabled="!editor.can().toggleHeaderCell()">
            Toggle header cell
          </button>
          <button @click="editor.chain().focus().mergeOrSplit().run()" :disabled="!editor.can().mergeOrSplit()">
            Merge or split
          </button>

          <button style="opacity: 0;">
            <i class="fa-solid fa-chevron-down" @click="toggleSecondRow" v-if="this.secondRow === false"></i>
            <i class="fa-solid fa-chevron-up" @click="toggleSecondRow" v-else></i>
          </button>

        </div>

      </div>

<bubble-menu
  class="bubble-menu flex flex-col"
  :tippy-options="{ duration: 100 }"
  :editor="editor"
>
  <div class="button-group editor flex gap-3 mb-2 bg-white p-3 rounded-lg pl-4 pr-4 justify-between" style="border-radius: 0px;  padding-bottom: 0rem;">

    <button @click="editor.chain().focus().addColumnBefore().run()" :disabled="!editor.can().addColumnBefore()">
      Add column before
    </button>

    <button @click="editor.chain().focus().addColumnAfter().run()" :disabled="!editor.can().addColumnAfter()">
      Add column after
    </button>

    <button @click="editor.chain().focus().deleteColumn().run()" :disabled="!editor.can().deleteColumn()">
      Delete column
    </button>

    <button @click="editor.chain().focus().addRowBefore().run()" :disabled="!editor.can().addRowBefore()">
      Add row before
    </button>

    <button @click="editor.chain().focus().addRowAfter().run()" :disabled="!editor.can().addRowAfter()">
      Add row after
    </button>
    <button @click="editor.chain().focus().deleteRow().run()" :disabled="!editor.can().deleteRow()">
      Delete row
    </button>

    <button @click="editor.chain().focus().deleteTable().run()" :disabled="!editor.can().deleteTable()">
      Delete table
    </button>

    <button @click="setLink">
      Add Link
    </button>

    <button>
      <i class="fa-solid fa-chevron-down" @click="toggleSecondRow" v-if="this.secondRow === false"></i>
      <i class="fa-solid fa-chevron-up" @click="toggleSecondRow" v-else></i>
    </button>

  </div>
  <div class="button-group editor flex gap-3 bg-white p-3 rounded-lg pl-4 pr-4 justify-between" v-if="secondRow" style="margin-top: 0rem; border-radius: 0px 0px 10px 10px; padding-bottom: 1rem; border-top: 1px solid #e3e3e3;  border-radius: 0px;  padding-top: 1.2rem;">

    <button @click="editor.chain().focus().mergeCells().run()" :disabled="!editor.can().mergeCells()">
      Merge cells
    </button>
    <button @click="editor.chain().focus().splitCell().run()" :disabled="!editor.can().splitCell()">
      Split cell
    </button>

    <button @click="editor.chain().focus().toggleHeaderColumn().run()" :disabled="!editor.can().toggleHeaderColumn()">
      Toggle header column
    </button>
    <button @click="editor.chain().focus().toggleHeaderRow().run()" :disabled="!editor.can().toggleHeaderRow()">
      Toggle header row
    </button>
    <button @click="editor.chain().focus().toggleHeaderCell().run()" :disabled="!editor.can().toggleHeaderCell()">
      Toggle header cell
    </button>
    <button @click="editor.chain().focus().mergeOrSplit().run()" :disabled="!editor.can().mergeOrSplit()">
      Merge or split
    </button>

    <button style="opacity: 0;">
      <i class="fa-solid fa-chevron-down" @click="toggleSecondRow" v-if="this.secondRow === false"></i>
      <i class="fa-solid fa-chevron-up" @click="toggleSecondRow" v-else></i>
    </button>

  </div>
</bubble-menu>
      
      <editor-content :editor="editor" />
      <div class="flex gap-4 float-left">
        <button class="custom-btn" @click="insertTableBeforeLastTable(editor, 3, 2, true)">+ Table Before</button>
        <button @click="insertTableAfterLastTable(editor, 3, 2, true)" class="custom-btn">+ Table After</button>
      </div>
      <div class="float-right flex gap-4">
        <button @click="editor.chain().focus().addRowBefore().run()"  class="custom-btn float-right">+ Row Before</button>
        <button @click="editor.chain().focus().addRowAfter().run()"  class="custom-btn float-right">+ Row After</button>
      </div>
    </div>
    
  </template>
<script>
import Table from '@tiptap/extension-table'
import TableCell from '@tiptap/extension-table-cell'
import TableHeader from '@tiptap/extension-table-header'
import TableRow from '@tiptap/extension-table-row'

import { TextSelection } from 'prosemirror-state'; 
import { NodeSelection } from 'prosemirror-state';
import { Node } from 'prosemirror-model';

import StarterKit from '@tiptap/starter-kit'
import { Editor, EditorContent, BubbleMenu } from '@tiptap/vue-3'
import Link from '@tiptap/extension-link'


const CustomTableCell = TableCell.extend({
  addAttributes() {
    return {
      // extend the existing attributes …
      ...this.parent?.(),

      // and add a new one …
      backgroundColor: {
        default: null,
        parseHTML: element => element.getAttribute('data-background-color'),
        renderHTML: attributes => {
          return {
            'data-background-color': attributes.backgroundColor,
            style: `background-color: ${attributes.backgroundColor}`,
          }
        },
      },
    }
  },
})

export default {
  components: {
    EditorContent,
    BubbleMenu,
  },

  data() {
    return {
      editor: null,
      secondRow: false
    }
  },

  props: {
    uuid: String,
    content: Object, 
  },

  methods: {
    
    setLink() {
        const previousUrl = this.editor.getAttributes('link').href
        const url = window.prompt('URL', previousUrl)

        // cancelled
        if (url === null) {
          return
        }

        // empty
        if (url === '') {
          this.editor
            .chain()
            .focus()
            .extendMarkRange('link')
            .unsetLink()
            .run()

          return
        }

        // update link
        this.editor
          .chain()
          .focus()
          .extendMarkRange('link')
          .setLink({ href: url })
          .run()
      },

    sendDataToParent() {
      const data = 'Hello Parent';
      this.$emit('sendData', data);
    },
    toggleSecondRow() {
        this.secondRow = !this.secondRow;
    },
    insertTableAfterLastTable(editor, rows, cols, withHeaderRow) {
        // Option 1: Using editor.state (if available)
        const { state, dispatch } = editor;  // Uncomment if using this approach
        const { $from } = state.selection;
        const parent = $from.node(1);

        // Check if the selection is within a table cell
        const isInsideTable = parent && (parent.type.name === 'table_cell' || parent.type.name === 'table_header' || parent.type.name === 'table');

        if (isInsideTable) {
            // Find the table node and its position
            let tablePos = $from.before(1);
            let tableNode = state.doc.nodeAt(tablePos);

            while (tableNode && tableNode.type.name !== 'table') {
            tablePos -= 1;
            tableNode = state.doc.nodeAt(tablePos);
            }

            if (tableNode) {
            // Insert a paragraph after the table to create space
            editor.commands.insertContentAt(tablePos + tableNode.nodeSize, {
                type: 'paragraph',
            });

            // Insert the table after the last table
            editor.chain().focus().insertTable({ rows, cols, withHeaderRow }).run();
            }
        } else {
            // If not inside a table, just insert the table at the current position
            editor.chain().focus().insertTable({ rows, cols, withHeaderRow }).run();
        }
    },
    insertTableBeforeLastTable(editor, rows, cols, withHeaderRow) {
        // Option 1: Using editor.state (if available)
        const { state, dispatch } = editor;  // Uncomment if using this approach
        const { $from } = state.selection;
        const parent = $from.node(1);

        // Check if the selection is within a table cell
        const isInsideTable = parent && (parent.type.name === 'table_cell' || parent.type.name === 'table_header' || parent.type.name === 'table');

        if (isInsideTable) {
            // Find the table node and its position
            let tablePos = $from.before(1);
            let tableNode = state.doc.nodeAt(tablePos);

            while (tableNode && tableNode.type.name !== 'table') {
            tablePos -= 1;
            tableNode = state.doc.nodeAt(tablePos);
            }

            if (tableNode) {
            // Insert a paragraph after the table to create space
            editor.commands.insertContentAt(tablePos, {
                type: 'paragraph',
            });

            // Insert the table after the last table
            editor.chain().focus().insertTable({ rows, cols, withHeaderRow }).run();
            }
        } else {
            // If not inside a table, just insert the table at the current position
            editor.chain().focus().insertTable({ rows, cols, withHeaderRow }).run();
        }
    }

  },
  mounted() {


    this.editor = new Editor({
      extensions: [
        StarterKit,
        Table.configure({
          resizable: true,
        }),
        TableRow,
        TableHeader,
        TableCell,
        // Custom TableCell with backgroundColor attribute
        CustomTableCell,
        Link.configure({
          openOnClick: false,
          defaultProtocol: 'https',
        }),
      ],
      // content: `
      //   <table>
      //     <tbody>
      //       <tr>
      //         <th>Educatie</th>
      //         <th></th>
      //       </tr>
      //       <tr>
      //         <td>2020 - 2024</td>
      //         <td>Sintlucas</td>
      //       </tr>
      //       <tr>
      //         <td>2024 - 2025</td>
      //         <td>Internal ICT</td>
      //       </tr>
      //     </tbody>
      //   </table>
      // `,
      content: this.content,
      onUpdate: ({ editor }) => {
        //const updatedContent = editor.getHTML();
        const updatedContent = editor;
        this.$emit('contentUpdated', updatedContent, this.uuid);
      }
    });

      // Emit the initial content on page load
        this.$nextTick(() => {
          const initialContent = this.editor;
          this.$emit('contentUpdated', initialContent, this.uuid);
        });


  },

  beforeUnmount() {
    this.editor.destroy()
  },
}
</script>

<style lang="scss">
.custom-btn {
    background: #176eff;
  padding: 12px;
    padding-right: 12px;
    padding-left: 12px;
  border-radius: 10px;
  padding-left: 15px;
  padding-right: 15px;
  color: white;
}

tr:nth-child(2n+1) {
  background-color: white !important;
}
tr td, tr th {
    padding:15px !important;
}
tr td {
    border: 1px solid #e9e9e9 !important;
}
tr:first-child {
    background:white;
}
table {
    border-radius:0px !important;
}

.tiptap a {
    text-decoration: underline;
   color: #176eff;
  }





  /* Table-specific styling */
  table {
    border-collapse: collapse;
    margin: 0;
    overflow: hidden;
    table-layout: fixed;
    width: 100%;

    td,
    th {
    //   border: 1px solid gray;
      box-sizing: border-box;
      min-width: 1em;
      padding: 6px 8px;
      position: relative;
      vertical-align: top;

      > * {
        margin-bottom: 0;
      }
    }

    th {
      background-color: #176eff;
      font-weight: 600;
      text-align: left;
      color:white;
    }

    .selectedCell:after {
      background: rgba(128, 128, 128, 0.116);
      content: "";
      left: 0; right: 0; top: 0; bottom: 0;
      pointer-events: none;
      position: absolute;
      z-index: 2;
    }

    .column-resize-handle {
      background-color: #e2e2e2;
      bottom: -2px;
      pointer-events: none;
      position: absolute;
      right: -2px;
      top: 0;
      width: 1px;
    }
  }

  .tableWrapper {
    margin: 1.5rem 0;
    overflow-x: auto;
  }
  .tiptap {
  &.resize-cursor {
    cursor: ew-resize;
    cursor: col-resize;
  }
}



</style>